import Crud from '../views/EntranceDoor/Crud'
import Entity from '../views/EntranceDoor/Add'

let routes = {
    path: '/entrance_doors',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/entrance_doors/add',
            name: 'NewEntranceDoors',
            component: Entity,
            meta: {
                pageTitle: 'Porta de Entradas',
                breadcrumb: [
                    {
                        text: 'Adicionar Porta de Entrada',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/entrance_doors/edit/:id?',
            name: 'EditEntranceDoors',
            component: Entity,
            meta: {
                pageTitle: 'Porta de Entradas',
                breadcrumb: [
                    {
                        text: 'Editar Porta de Entrada',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/entrance_doors',
            name: 'list-entrance-doors',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Porta de Entradas',
                breadcrumb: [
                    {
                        text: 'Porta de Entradas',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
